export const AUTH_ERROR = 'AUTH_ERROR'
export const SET_CAMPAIGN = 'SET_CAMPAIGN'

export function setCampaignAndToken(campaignId, token) {
  return dispatch => new Promise(resolve => {
      dispatch({
        type: SET_CAMPAIGN,
        data: {
          campaignId,
          token
        }
      })

      resolve(campaignId)
    })
}
